import { render } from "./PricingPlanThree.vue?vue&type=template&id=0788ea3b"
import script from "./PricingPlanThree.vue?vue&type=script&lang=js"
export * from "./PricingPlanThree.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larijuva/suha-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__